import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppRouter } from './router';
import './index.css';

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000
    }
  }
});

// A deploy replaces the hashed chunk files, so a tab still running the previous
// index.html fails to lazy-load a chunk that no longer exists ("Failed to fetch
// dynamically imported module", e.g. on /system-map's 3D graph). Reload once to
// pick up the fresh index.html + current chunks; the timestamp guard prevents a
// loop if a chunk is genuinely missing.
window.addEventListener('vite:preloadError', () => {
  const KEY = 'nurev_chunk_reload_at';
  const last = Number(sessionStorage.getItem(KEY) || 0);
  if (Date.now() - last < 10_000) return;
  try {
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    /* sessionStorage unavailable — fall through and reload anyway */
  }
  window.location.reload();
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <AppRouter />
    </QueryClientProvider>
  </React.StrictMode>
);
